export default {
  state: {
    carPlatFormType: '',
    placeType: 1, // 1- 出发地 2-目的地
    mapCenter: [116.396087, 39.909882], // 地图中心点 北京-[116.396087, 39.909882] 苏州火车站-[120.610868, 31.329679] 协鑫广场-[120.716725, 31.324579]
    curPositionInfo: {}, // 当前位置信息
    startLocation: [], // 用车起始点位置
    endLocation: [], // 用车目的地位置
    startPlaceInfo: {}, // 用车起始地信息
    endPlaceInfo: {}, // 用车目的地信息
    locationInfo: {}, // 位置信息
    greenAreaInfo: {}, // 当前绿区信息
    startPlaceCityInfo: {}, // 起始位置城市信息
    endPlaceCityInfo: {}, // 目的地位置城市信息
    carUseTimeInfo: {
      timeVal: '',
      timeValFormat: '现在出发',
    }, //用车时间信息
    requestLoading: false, // 请求位置信息加载状态
    carAbOrderList: [], // 用车未完成订单列表
    mapEnlarge: false, // 地图是否放大
    greenPopupShow: false, // 是否显示绿区
    errStatus: false, // 是否是uni定位错误
  },
  mutations: {
    // 设置用车平台
    setCarPlatFormType(state, data) {
      state.carPlatFormType = data;
    },
    // 设置地图中心点
    setMapCenter(state, data) {
      state.mapCenter = data;
    },
    // 设置当前位置信息
    setCurPosition(state, data) {
      state.curPositionInfo = data;
    },
    // 设置用车起始点位置
    setStartLocation(state, data) {
      state.startLocation = data;
    },
    // 设置用车起始地信息
    setStartPlaceInfo(state, data) {
      state.startPlaceInfo = data;
    },
    // 设置用车目的地位置
    setEndLocation(state, data) {
      state.endLocation = data;
    },
    // 设置用车目的地信息
    setEndPlaceInfo(state, data) {
      state.endPlaceInfo = data;
    },
    setRequestLoading(state, data) {
      state.requestLoading = data;
    },
    setErrStatus(state, data) {
      state.errStatus = data;
    },
    setLocationInfo(state, data) {
      state.locationInfo = data;
    },
    // 设置用车类型
    setPlaceType(state, data) {
      state.placeType = data;
    },
    // 设置绿区信息
    setGreenAreaInfo(state, data) {
      state.greenAreaInfo = data;
    },
    // 设置起始地城市信息
    setStartPlaceCityInfo(state, data) {
      state.startPlaceCityInfo = data;
    },
    // 设置目的地城市信息
    setEndPlaceCityInfo(state, data) {
      state.endPlaceCityInfo = data;
    },
    // 设置用车时间信息
    setCarUseTimeInfo(state, data) {
      state.carUseTimeInfo = data;
    },
    // 设置未完成订单数据
    setAbOrderList(state, data) {
      state.carAbOrderList = data;
    },
    // 设置放大缩小状态
    setMapEnlarge(state, data) {
      state.mapEnlarge = data;
    },
    setGreenPopupShow(state, data) {
      state.greenPopupShow = data;
    },
  },
  actions: {},
};
